import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/service/common.service';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { MenuIdService } from 'src/app/service/menu-id.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  submitted: boolean = false
  ChangePwdForm!: FormGroup;
  url: any;
  imageURL:any;
  constructor(private fb: FormBuilder,
    private dialog: MatDialog,
    private loader: LoaderService,
    private restService: RestService,
    private translate: TranslateService,
    private commonService: CommonService, private route: ActivatedRoute,
    public menuIdService: MenuIdService,) { }

  ngOnInit(): void {
    this.imageURL = this.menuIdService.getActiveImageURL();
    this.ChangePwdForm = this.fb.group({
      currentPassword: ['', [Validators.required,  Validators.pattern(/[a-z]/),     // At least one lowercase letter.
      Validators.pattern(/[A-Z]/),     // At least one uppercase letter.
      Validators.pattern(/\d/),        // At least one digit.
      Validators.pattern(/[@#$%^&+=]/) // At least one special character.
    ]],
      confirmPassword: ['', [Validators.required,  Validators.pattern(/[a-z]/),     // At least one lowercase letter.
      Validators.pattern(/[A-Z]/),     // At least one uppercase letter.
      Validators.pattern(/\d/),        // At least one digit.
      Validators.pattern(/[@#$%^&+=]/) // At least one special character.
    ]],
      newPassword: ['', [Validators.required,  Validators.pattern(/[a-z]/),     // At least one lowercase letter.
      Validators.pattern(/[A-Z]/),     // At least one uppercase letter.
      Validators.pattern(/\d/),        // At least one digit.
      Validators.pattern(/[@#$%^&+=]/) // At least one special character.
    ]]
    }, { validator: this.passwordMatchValidator });
    this.route.url.subscribe(url => {
      this.url = url[0].path;
    });
  }
  get control() {
    return this.ChangePwdForm.controls;
  }

  onSubmit(data: any) {
    this.submitted = true;

    if (this.ChangePwdForm.invalid) {
      return;
    }

    const params = {
      "oldPassword": this.ChangePwdForm.value.currentPassword.trim(),
      "newPassword": this.ChangePwdForm.value.newPassword.trim()
    };

    const apiurl = data === 'change_password'
      ? 'api/digital/core/User/UpdateUserPassword'
      : 'api/digital/core/User/UpdateTransactionPassword';

    this.restService.postUATData(params, apiurl).subscribe({
      next: (response: any) => {
        this.loader.hide();
        if(response.rcode == 200){
          let _dialogRef = this.dialog.open(MatDialogComponent, {
            width: '50VW',
            disableClose: true,
            data: {
              success: true,
              trnID: data.transactionRef,
              errorMessage: "Password updated successfully!"
            }
          })
          _dialogRef.afterClosed().subscribe(result => {
            if (result) {
            history.back()
            }
          })
        }
        else if(response.rcode !== 200) {

          const errorCode = response.rmsg[0].errorCode || 'ERROR';
          const errorMessage = this.translate.instant(errorCode);

          const _dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: {
              secondary: true,
              transactionReference: response.rmsg[0].transactionReference || null,
              errorMessage
            }
          });

          _dialogRef.afterClosed().subscribe(result => {
            // Handle dialog close
          });
        }
      },
      error: (error: any) => {
        this.loader.hide();
        const errorCode = error.error.rmsg[0].errorCode || 'ERROR';
        this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
      }
    });
  }

  passwordMatchValidator(form: FormGroup): ValidationErrors | null {
    if (form.get('newPassword')?.value === form.get('confirmPassword')?.value) {
      return null; // if passwords match, return null (no error)
    } else {
      return { passwordMismatch: true }; // if passwords don't match, return error
    }
  }
  back(){
    history.back()
  }
}
